import { Moment } from 'moment';
import * as moment from 'moment/moment';

export class DateUtils {

  public static startOfToday(): Moment {
    return moment().startOf('day');
  }

  public static endOfToday(): Moment {
    return moment().endOf('day');
  }

  public static startOfDateIsoString(date: string): string {
    return date ? moment(date).startOf('day').toISOString() : null;
  }

  public static endOfDateIsoString(date: string): string {
    return date ? moment(date).startOf('day').toISOString() : null;
  }

  public static simpleDateNow(): string {
    return moment().format().slice(0, -15);
  }

  public static formatToSimpleDate(date: Moment): string {
    return date.format().slice(0, -15);
  }

  public static getNavTimezone(): string {
    return moment.tz.guess();
  }
}
